import { render, staticRenderFns } from "./save-request-list-modal.vue?vue&type=template&id=004f8ab8"
import script from "./save-request-list-modal.vue?vue&type=script&lang=js"
export * from "./save-request-list-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports